import { defineStore } from 'pinia'
import { shallowRef, ref, computed } from 'vue'

export const useModalsStore = defineStore(
  'modals',
  () => {
    const modals = ref([])

    const activeModal = computed(() => {
      return modals.value.length > 0 ? modals.value[modals.value.length - 1] : null
    })

    function open(component, props) {
      return new Promise((resolve, reject) => {
        const modal = {
          component: shallowRef(component),
          props,
          resolve,
          reject
        }
        modals.value.push(modal)
      })
    }

    function close(data) {
      const modal = activeModal.value
      if (modal) {
        modals.value.pop()
        modal.resolve(data)
      }
    }

    function cancel(reason) {
      const modal = activeModal.value
      if (modal) {
        modal.reject(reason)
        modals.value.pop()
      }
    }

    return {
      modals,
      activeModal,
      open,
      close,
      cancel
    }
  },
  { persist: false }
)


